import { ICartProduct } from '@ddot/AddToCartCommon/lib/entities';
import { createAsyncThunk } from '@reduxjs/toolkit';

import Selectors from 'Redux/Selectors';

import { AsyncThunkAPI } from 'Redux/types';
import Actions from 'Redux/Actions';
import Atc from '../../../../Lib/ATC';

import { OrderErrorTypes } from '.';

export interface IPaymentDetailsParams {
    paymentId: string;
}

export interface PaymentDetailsApiResponse {
    orderId: string,
    orderNumber: string,
    paymentStatus: number,
    amountPaid: number,
    products: ICartProduct[],
    currency: string;
}

export default createAsyncThunk<
    PaymentDetailsApiResponse,
    IPaymentDetailsParams,
    AsyncThunkAPI
>('order/getPaymentDetails', async (params, thunkAPI) => {
    const response = await thunkAPI.extra.useCases.order.getPaymentDetails.execute(params);

    if (response.status === Atc.UseCases.Types.UseCaseResponseStatus.Success) {
        return response.data;
    }

    if (response.data.type === OrderErrorTypes.GetPaymentDetailsError.ServerError) {
        return thunkAPI.rejectWithValue(response.data.message || 'Something went wrong. Please try again.');
    }

    return thunkAPI.rejectWithValue('Something went wrong. Please try again.');
});
